import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
import DragToolsUI, { DraggedSingleData } from './DragToolsUI';

var currentToolbagConfig: ToolbagUIConfig = null;

const ToolbagUI = (props: UIProperties<ToolbagUIConfig>) => {
	const [showOverlay, setShowOverlay] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [draggedData, setDraggedData] = useState(null);

	(window as any).onForceToolbagRerender = (config: ToolbagUIConfig) => {
		currentToolbagConfig = config;
		setForceUpdate(!forceUpdate);
	}
	
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div tabIndex={0} style={{
				position: 'absolute',
				width: '140px',
				height: (82*5) + 'px',
				top: '430px',
				left: '10px'
			}} aria-label="Start of toolbag area" id="toolbag-bttn-top">
				{draggedData && !showOverlay ? (
					draggedData.map((data: DraggedSingleData, indx: number) => {
						var startingTop = 331- (draggedData.length * 82);
						// var startingTop = 678;
						var currentTop = startingTop+(82*indx);
						var img = null;
						switch(data.text) {
							case constants.toolbagTools.bvm.text:
								img = './assets/images/Toolbag/icon_bvm.png';
								break;
							case constants.toolbagTools.ett.text:
								img = './assets/images/Toolbag/icon_ett.png';
								break;
							case constants.toolbagTools.sga.text:
								img = './assets/images/Toolbag/icon_lma.png';
								break;
							case constants.toolbagTools.cric.text:
								img = './assets/images/Toolbag/icon_scalpel.png';
								break;
						}

						return img ? (<CustomToolbagButton 
									key={Tools.generateGuid()}
									foregroundImg={img}
									showYellowThingyOnTheSide={false}
									isDisabled={currentToolbagConfig.isDisabled}
									width= '118px'
									text={data.text}
									position= {{
										type: 'absolute',
										top: currentTop + 'px',
										left: '21px'
									}}
									onClicked={() => {
										currentToolbagConfig.onToolClicked(data);
									}}/>) : (null)
					})
					
				) : (null)}
				<CustomToolbagButton 
					foregroundImg='./assets/images/Toolbag/icon_toolbag.png'
					showYellowThingyOnTheSide={true}
					id="toolbag-bttn-end"
					width= '140px'
					text='Tool Bag'
					position= {{
						top: '331px',
						left: '0px'
					}}
					onClicked={() => {
						if(!currentToolbagConfig.onShouldShowOverlay()) {
							return;
						}
						setShowOverlay(true);
					}}/>
			</div>
			
			
			{showOverlay ? (
				<DragToolsUI id={Tools.generateGuid()} key={Tools.generateGuid()} parameters={{
					isTestScenario: currentToolbagConfig.isTestScenario,
					onIncorrectToolPicked: currentToolbagConfig.onIncorrectToolPicked,
					onClose: () => {
						setShowOverlay(false)
					},
					toolsToChooseFrom: currentToolbagConfig.toolsToChooseFrom,
					onToolsArranged: (text: string[], draggedData: DraggedSingleData[]) => {
						if(currentToolbagConfig.onToolsArranged) {
							currentToolbagConfig.onToolsArranged(text);
						}
						// draggedData.reverse();
						setDraggedData(draggedData)
					}
				}}></DragToolsUI>
			) : (null)}
		</div>
	);
};

const CustomToolbagButton = (props: CustomToolbagButtonConfig) => {
	const get508Text = () => {
		if(props.text.toLocaleLowerCase().trim() === 'cric' || props.text.toLocaleLowerCase().trim() === 'tool bag') {
			return props.text;
		}
		return props.text.split('').join(' ');
	}
	return (
		<div id={props.id} style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					ariaLbl: get508Text(),
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large_disabled.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					},
					onPressAndHold: () => {
						var method =  (event: any) => {
							if(props.onDragEnd) {
								props.onDragEnd();
							}
							window.removeEventListener('mouseup', method);
						};
						window.addEventListener('mouseup', method);

						if(props.onDragStart) {
							props.onDragStart();
						}
					},
					onMouseOut: () => {
						if(props.onMouseOut) {
							props.onMouseOut()
						}
					},
					onMouseOver: () => {
						if(props.onMouseOver) {
							props.onMouseOver()
						}
					}
				}}/>
				<div style={{
						position: 'relative',
						top: '13px',
						height: 'calc(calc(' + props.width+'/2)-3px)',
						pointerEvents: 'none',
				}}>
					{props.foregroundImg ? <img style={{
						position: 'relative',
						top: '0',
						left: '50%',
						transform: 'translate(-50%, 0)',
						width: props.width === '140px' ? '60px' : '50px'
					}} src={props.foregroundImg} /> : (null)}
				</div>
				
				<div style={{
					position: 'absolute',
					height: '19px',
					pointerEvents: 'none',
					width: '70%',
					left: '12px',
					top: props.text === 'Tool Bag' ? '69px' : undefined
				}}>
					<div style={{
						position: 'relative',
						top: '0'
					}}>
						<p className='title-font' style={{
							textAlign: 'right',
							margin: '0',
							fontSize: '8pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-21px',
						width: '28px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomToolbagButtonConfig {
	text: string;
	id?: string;
	width: string;
	position: CustomToolbagButtonPosition;
	foregroundImg: string;
	showYellowThingyOnTheSide?: boolean;
	isDraggable?: boolean;
	isDisabled?: boolean;
	onClicked?: () => void;
	onDragStart?: () => void;
	onDragEnd?: () => void;
	onMouseOver?: () => void;
	onMouseOut?: () => void;
}

interface CustomToolbagButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface ToolbagUIConfig extends BaseConfig{
	isTestScenario?: boolean;
	onIncorrectToolPicked?: () => void;
	onShouldShowOverlay?: () => boolean;
	toolsToChooseFrom?: DraggedSingleData[];
	isDisabled?: boolean;
	onToolClicked?: (toolInfo: DraggedSingleData) => void;
	onToolsArranged?: (text: string[]) => void;
}

export default ToolbagUI;